import Icon from '../icon/Icon';
import { ChipProps } from './types';

const Chip = ({
  label,
  className,
  style,
  onRemove,
  handleChipClick,
  isCloseIconRequired = true,
  labelStyle = 'max-w-20',
  size
}: ChipProps) => (
  <div
    role="presentation"
    onClick={(e) => handleChipClick?.(label, e)}
    className={`${
      className || ''
    } flex h-7 w-fit items-center rounded-2xl px-2.5 py-[5px] text-sm font-normal text-cofeeNeutral10 `}
    style={style}
  >
    <div title={label} className={`truncate break-words ${labelStyle || ''}`}>
      {label}
    </div>
    {isCloseIconRequired && onRemove && (
      <div
        role="presentation"
        onClick={onRemove}
        className="ml-2 cursor-pointer"
      >
        <Icon
          name="close-custom-color"
          size={size ?? '12'}
          className="text-cofeeNeutral8"
        />
      </div>
    )}
  </div>
);

export default Chip;
